/**
 * Shared helpers for Stimulus controllers (CSRF, JSON fetch, escaping).
 */

/** CSRF token from the meta tag Rails injects in the layout. */
export function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta?.getAttribute("content") || meta?.content || ""
}

/** Escape text for safe insertion as HTML text nodes. */
export function escapeHtml(str) {
  if (str == null || str === "") return ""
  const div = document.createElement("div")
  div.textContent = str
  return div.innerHTML
}

const JSON_HEADERS = {
  "Content-Type": "application/json",
  Accept: "application/json",
  "X-Requested-With": "XMLHttpRequest",
}

/**
 * JSON fetch with CSRF on mutating methods.
 * @param {string} url
 * @param {RequestInit} [options]
 * @returns {Promise<any>} Parsed JSON body
 */
export async function fetchJson(url, options = {}) {
  const method = (options.method || "GET").toUpperCase()
  const headers = {
    ...JSON_HEADERS,
    ...options.headers,
  }
  if (method !== "GET" && method !== "HEAD" && !headers["X-CSRF-Token"]) {
    headers["X-CSRF-Token"] = csrfToken()
  }

  const response = await fetch(url, { ...options, headers })

  const text = await response.text()
  let data
  try {
    data = text ? JSON.parse(text) : null
  } catch {
    throw new Error(`Invalid JSON from ${url}`)
  }

  if (!response.ok) {
    const err = new Error(data?.error || response.statusText || `HTTP ${response.status}`)
    err.status = response.status
    err.data = data
    throw err
  }

  return data
}
